import React from 'react';
import userProfile from '../../../assets/images/userProfile.svg';
import CustomerCall from '../../../assets/images/call.svg';
import CustomerSms from '../../../assets/images/sms.svg';
import CustomerLocation from '../../../assets/images/location.svg';

interface EquipmentOwnerDetailsProps {
  equipmentDetailsData: any;
}

const EquipmentOwnerDetails: React.FC<EquipmentOwnerDetailsProps> = ({
  equipmentDetailsData,
}) => {
  return (
    <section className="customer_management_name-edit">
      <div className="customer_management_name-edit-customer">
        <h5>Owner - {equipmentDetailsData?.customerName || ''}</h5>
        <div className="customer_management_name-edit-address customer_management_name-equipment_details ">
          <div className="customer_management_name-edit-address-profile">
            <img
              src={equipmentDetailsData?.ownerImg || userProfile}
              alt="customer"
            />
          </div>

          <div>
            <div className="customer_management_name-edit-address-contact">
              <div className="customer_management_name-edit-address-contact-img">
                <img
                  src={CustomerCall}
                  width="24px"
                  height="24px"
                  alt="CustomerCall"
                />{' '}
                <h6>{equipmentDetailsData?.mobileNo || '-'}</h6>
              </div>
              <div className="customer_management_name-edit-address-contact-img">
                <img
                  src={CustomerSms}
                  width="24px"
                  height="24px"
                  alt="CustomerSms"
                />{' '}
                <h6>{equipmentDetailsData?.email || '-'}</h6>
              </div>
            </div>
            <div className="customer_management_name-edit-address-contact-img">
              <img
                src={CustomerLocation}
                width="24px"
                height="24px"
                alt="CustomerLocation"
              />{' '}
              <h6>{equipmentDetailsData?.address || '-'}</h6>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const MemoizedComponent = React.memo(EquipmentOwnerDetails);
export default MemoizedComponent;
